import { pct, pctColor } from "@/lib/kpi";

export default function Gauge({ value, objective, size = 72 }) {
  const p = pct(value, objective);
  const fill = pctColor(p);
  const r = size * 0.388; // 28 at size 72
  const c = size / 2;
  const circ = 2 * Math.PI * r;
  const dash = (Math.min(p, 100) / 100) * circ;
  const stroke = size * 0.097; // 7 at size 72
  const fontSize = Math.max(10, Math.round(size * 0.155));

  return (
    <svg width={size} height={size} style={{ flexShrink: 0 }} aria-hidden="true">
      <circle cx={c} cy={c} r={r} fill="none" stroke="#f0f0f0" strokeWidth={stroke} />
      <circle
        cx={c}
        cy={c}
        r={r}
        fill="none"
        stroke={fill}
        strokeWidth={stroke}
        strokeDasharray={`${dash} ${circ}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${c} ${c})`}
        style={{ transition: "stroke-dasharray .5s" }}
      />
      <text
        x={c}
        y={c + 1}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={fontSize}
        fontWeight="700"
        fill={fill}
        fontFamily="Inter, sans-serif"
      >
        {p}%
      </text>
    </svg>
  );
}
